module.exports = __webpack_public_path__ + "img/notification-icon.a5192118.svg";